export default __webpack_public_path__ + "static/media/W51Bath.6cfa28e7.jpg";